import ErrorIcon from '@mui/icons-material/Error';
import { Alert, Box, Typography } from '@mui/material';

const MenuZipcodeInfoWidget = ({ data, dataError }) => {
  const parsedCoverage = Number(data?.coverage);
  const coveragePercentage = Number.isFinite(parsedCoverage)
    ? Math.min(100, Math.max(0, parsedCoverage))
    : 0;

  const getCoverageQuality = (coverage) => {
    if (coverage < 25) return 'Mala';
    if (coverage < 50) return 'Regular';
    if (coverage < 80) return 'Buena';
    return 'Excelente';
  };

  const coverageStatus = getCoverageQuality(coveragePercentage);
  const integerCoverage = Math.floor(coveragePercentage);
  const decimalCoverage = coveragePercentage - integerCoverage;
  const coverageDisplay = decimalCoverage >= 0.6 ? integerCoverage + 1 : integerCoverage;

  const { municipality, state, zipcode } = data || {};

  // Se incrementó el radio para hacer el semicírculo más grande
  const radius = 110;
  const circumference = Math.PI * radius; // Perímetro de un semicírculo
  const strokeDashoffset = circumference - (coveragePercentage / 100) * circumference;

  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 3, width: '100%' }}
    >
      {dataError ? (
        // --- ESTADO DE ERROR ---
        <Box sx={{ width: '100%', maxWidth: 380, mb: 4 }}>
          <Typography variant='h6' color='error' sx={{ mb: 1, textAlign: 'center' }}>
            Error al consultar la información
          </Typography>
          <Alert severity='error' icon={<ErrorIcon />}>
            {dataError}
          </Alert>
        </Box>
      ) : (
        // --- NUEVO ESTADO DE ÉXITO (DISEÑO DE COBERTURA) ---
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
            maxWidth: 340,
          }}
        >
          {/* Gráfico de Medidor (Gauge) */}
          <Box sx={{ position: 'relative', width: 280, height: 160, mt: 2 }}>
            <svg width='280' height='160' viewBox='0 0 280 160'>
              {/* Fondo gris del medidor */}
              <path
                d='M 30 140 A 110 110 0 0 1 250 140'
                fill='none'
                stroke='#B5B5C3'
                strokeWidth='28'
                strokeLinecap='round'
              />
              {/* Progreso morado del medidor */}
              <path
                d='M 30 140 A 110 110 0 0 1 250 140'
                fill='none'
                stroke='#5B167A'
                strokeWidth='28'
                strokeLinecap='round'
                strokeDasharray={circumference}
                strokeDashoffset={strokeDashoffset}
                style={{ transition: 'stroke-dashoffset 1s ease-in-out' }}
              />
            </svg>

            {/* Etiquetas externas del medidor reubicadas para el nuevo tamaño */}
            <Typography
              sx={{ position: 'absolute', top: 20, left: 10, fontSize: '0.9rem', fontWeight: 500 }}
            >
              Regular
            </Typography>
            <Typography
              sx={{ position: 'absolute', top: 20, right: 10, fontSize: '0.9rem', fontWeight: 500 }}
            >
              Buena
            </Typography>
            <Typography
              sx={{
                position: 'absolute',
                bottom: -20,
                left: 20,
                fontSize: '0.9rem',
                fontWeight: 500,
              }}
            >
              Mala
            </Typography>
            <Typography
              sx={{
                position: 'absolute',
                bottom: -20,
                right: 5,
                fontSize: '0.9rem',
                fontWeight: 500,
              }}
            >
              Excelente
            </Typography>

            {/* Porcentaje al centro */}
            <Typography
              sx={{
                position: 'absolute',
                bottom: 25,
                left: 0,
                right: 0,
                textAlign: 'center',
                fontSize: '2rem',
                fontWeight: 'bold',
              }}
            >
              {coverageDisplay}%
            </Typography>
          </Box>

          {/* Textos de Estado de Cobertura */}
          <Typography
            sx={{
              color: '#5B167A',
              fontSize: '1.8rem',
              fontWeight: 'bold',
              mt: 3,
              lineHeight: 1.2,
            }}
          >
            {coverageStatus}
          </Typography>
          <Typography
            sx={{ color: '#000', fontSize: '1.4rem', fontWeight: 'bold', mb: 3, lineHeight: 1.2 }}
          >
            Cobertura
          </Typography>

          {/* Tarjeta de Ubicación (Fondo lila) */}
          <Box
            sx={{
              backgroundColor: '#F6F2FF',
              borderRadius: 4,
              p: 2.5,
              width: '100%',
              textAlign: 'center',
              mb: 4,
            }}
          >
            <Typography sx={{ color: '#5B167A', fontWeight: 500, mb: 0.5 }}>
              Municipio: {municipality}
            </Typography>
            <Typography sx={{ color: '#5B167A', fontWeight: 500, mb: 0.5 }}>
              Estado: {state}
            </Typography>
            <Typography sx={{ color: '#5B167A', fontWeight: 500 }}>C.P: {zipcode}</Typography>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default MenuZipcodeInfoWidget;
